'use strict';

const LoginErrorDirective = function () {

  /**
   * creates a watch group for a form's inputs to remove the error message when the user begins typing again
   * @param {object} scope directive scope
   */
  const setWatches = (scope) => {

    const props = scope.inputs.map((input) => {

      return `form.${input}.$viewValue`;
    });

    scope.$watchGroup(props, () => {

      if (scope.error) {
        scope.error = '';
      }
    });
  };

  const link = (scope, el, attrs, form) => {

    scope.form = form;

    setWatches(scope);

    scope.$watch('error', (e) => {

      if (e && !scope.text) {
        scope.text = e.friendlyMessage ? e.friendlyMessage : e.message;
      }
    });
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////
  /**
   * error:  {object} error returned from api
   * inputs: {array}  input names used to set up watches (must match names declared in HTML)
   * text:   {string} error message to be displayed to the user (optional: defaults to error.friendlyMessage or error.message if not provided)
   */
  return {
    require: '^form',
    scope: {
      error: '=',
      inputs: '=',
      text: '='
    },
    link,
    templateUrl: 'login/templates/loginError.tpl.html'
  };
};

module.exports = LoginErrorDirective;



// WEBPACK FOOTER //
// ./src/app/login/directives/LoginErrorDirective.js